"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _Text = require("../../Text/Text");
var _glyphs = require("@catalytic/catalytic-icons/lib/glyphs");
var _Grid = _interopRequireDefault(require("../../Grid/Grid.js"));
var _excluded = ["classes", "className", "description", "isPinned", "menu", "name", "theme"];
/*:: // 

import { type Node } from 'react';*/
/*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    name: {
      backgroundColor: theme.colors.lightGrey,
      borderRadius: theme.variables.borderRadiusSmall,
      color: theme.colors.pebbleGrey
    },
    description: {
      color: theme.colors.battleshipGrey,
      display: 'block'
    },
    pin: {
      color: theme.colors.battleshipGrey,
      marginLeft: '.25rem',
      fontSize: '.75rem'
    }
  };
};
/*:: type Props = InjectSheetProvidedProps &
  HTMLDivElement & {
    className?: string,
    description?: string,
    isPinned?: boolean,
    menu?: Node,
    name: string
  };*/
var FieldHandlebar = function FieldHandlebar(_ref /*:: */) {
  var classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    description = _ref /*:: */.description,
    isPinned = _ref /*:: */.isPinned,
    menu = _ref /*:: */.menu,
    name = _ref /*:: */.name,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/ /*: Node*/_react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, props), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    wrap: "nowrap",
    justify: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Text.ExtraSmallText, {
    className: classes.name
  }, name), isPinned ? /*#__PURE__*/_react.default.createElement(_glyphs.PinGlyph, {
    className: classes.pin
  }) : null), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, menu)), description && /*#__PURE__*/_react.default.createElement(_Text.ExtraSmallText, {
    className: classes.description
  }, description));
};
FieldHandlebar.displayName = 'FieldHandlebar';
var _default = exports.default = (0, _injectSheet.default)(Style)(FieldHandlebar);
//# sourceMappingURL=FieldHandlebar.js.map